import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';
import { routerSegments } from '@consts/routes';
import { AppState } from '../store/app.state';
import { OrganizationSelectors } from '@states/organization/organization.selector-types';
import type { ActiveOrganization } from '@models/organization.model';

/**
 * Blocks `/chat` when org Matrix chat is off (`chatStatus === true`), matching sidebar visibility.
 * Waits for `activeOrganization` before deciding so the store is not treated as “chat off” while still empty.
 */
export const chatMatrixFeatureGuard: CanActivateFn = () => {
  const store = inject<Store<AppState>>(Store);
  const router = inject(Router);

  return store.select(OrganizationSelectors.selectActiveOrganization).pipe(
    filter((org): org is ActiveOrganization => org != null),
    take(1),
    map((org) =>
      org.chatStatus === true
        ? true
        : router.createUrlTree([routerSegments.home]),
    ),
  );
};
